export const environment = {
  production: true,
  version: "v 1.4.0-rc.9",
  versionCheckURL: "https://staging.get-flipped.app/version.json",
  appInsights: {
    connectionString:
      "InstrumentationKey=3fddb7e9-d84d-4b66-b318-ccaf20383768;IngestionEndpoint=https://australiasoutheast-0.in.applicationinsights.azure.com/;LiveEndpoint=https://australiasoutheast.livediagnostics.monitor.azure.com/;ApplicationId=f1f3a8bb-844d-4781-b765-adc1d9594bc0",
  },
  apiBaseUrl: "https://api.staging.get-flipped.app",
  communityForumUrl: "https://community.get-flipped.app",
  // Controls the "Create one" register link on the login page in the browser.
  // The mobile app shows it regardless of this flag.
  showWebRegisterLink: true,  // browser sign-up allowed on staging for testing
  vapidPublicKey:
    "BHxptOW1_AdAYI_MQXL9mefAwgxQDvLR9zSM60QutBK85n2BuVqHFtcyHo1DhP1qT6lMmIs80nWJSHT3K3eBEBI",
};
